import React from 'react';

type StatusRowProps = {
  statusIcon: React.ReactNode;
  color?: string;
  children: React.ReactNode;
};

const StatusRow = ({ statusIcon, color, children }: StatusRowProps) => (
  <div className="d-flex align-items-center">
    <div className="me-1 d-flex align-items-center align-self-center" style={{ minHeight: '20px' }}>{statusIcon}</div>
    <div className="flex-grow-1" style={{ color }}>{children}</div>
  </div>
);

export default StatusRow;
